


























































































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';
import { OrganisationService } from '@store/service/OrganisationService';
import ErrorResponseMixin from '@mixin/errorResponse';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            errorData: null,
            submitted: false,
            post: {}
        };
    },

    mixins: [
        ErrorResponseMixin,
    ],

    created() {
        this.organisationService = new OrganisationService(this.$store);
        this.post = { ...this.organisation };
    },

    methods: {
        submit() {
            if (this.submitted) return;

            this.$validator.validate().then(valid => {
                if (!valid) return;

                this.submitted = true;

                this.organisationService.putOrganisation(this.organisation.id, { ...this.post }).then(response => {
                    if (response instanceof Error) {
                        this.errorData = this.getErrorMessage(response);
                        this.submitted = false;
                        return false;
                    }

                    this.$router.push('/profile');
                });
            });
        }
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class OrganisationForm extends Vue {
    @Prop() organisation!: object;
}

